import './index.scss'

import { useState } from 'react'

import { useAuth } from '@auth/AuthProvider'
import Modal from '@components/Modal'
import VolunteeringController from '@data/controller/VolunteeringController'

import closeIcon from 'url:@icon/close.svg';

export type RemoveVolunteerTarget = {
  personID: string;
  personName: string;
  teamID: string;
  teamName: string;
};

export default function RemoveVolunteerModal(props: {
  isOpen: boolean,
  target?: RemoveVolunteerTarget | null,
  close: () => void,
  onRemoved: () => void
}) {
  const auth = useAuth();
  const [isRemoving, setIsRemoving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const removeVolunteer = async () => {
    if (!auth.churchId || !props.target) {
      setError('Missing church context. Please refresh and try again.');
      return;
    }

    setIsRemoving(true);
    setError(null);

    try {
      const response = await VolunteeringController.removeTeamMember(
        auth.churchId,
        props.target.teamID,
        props.target.personID,
        auth
      );

      if (response.error) {
        setError(response.error);
        setIsRemoving(false);
        return;
      }

      props.onRemoved();
    } finally {
      setIsRemoving(false);
    }
  };

  return <Modal
    id='remove-volunteer-modal'
    isOpen={props.isOpen}
    footerButtons={[]}>
    <div className='remove-volunteer-modal-content'>
      <div className='header'>
        <button
          type='button'
          className='header-control close'
          disabled={isRemoving}
          onClick={props.close}>
          <img src={closeIcon} alt='Close icon' />
        </button>

        <h3 className='title'>Remove Volunteer</h3>

        <span className='header-control-spacer' />
      </div>

      <div className='body'>
        {error ? <p className='save-error'>{error}</p> : null}

        <p className='remove-copy'>
          <strong>Remove {props.target?.personName ?? 'this volunteer'} from the {props.target?.teamName ?? 'this team'} team?</strong>
        </p>

        <p className='caption'>This action does not delete them from your church's People list. You can invite them back to this team at any time.</p>

        <div className='remove-actions'>
          <button
            type='button'
            className='remove-button'
            disabled={isRemoving}
            onClick={() => {
              void removeVolunteer();
            }}>
            {isRemoving ? 'Removing...' : 'Remove from Team'}
          </button>
        </div>
      </div>
    </div>
  </Modal>
}
